var lib_core      = require("lib-core");
var lib_geometry      = require("lib-geometry");
var THREE         = require("three");
var GlobalRotationModel  = require("./../abstract/globalRotationHandleModel.js");

var GlobalXRotationModel = function (editorModel, handleId, config) {
    GlobalRotationModel.call(this, editorModel, handleId, config);

    this.axis = new THREE.Vector3(1,0,0);
};

lib_core.inherit(GlobalXRotationModel, GlobalRotationModel);
GlobalXRotationModel.$class = "GlobalXRotationModel";
module.exports = GlobalXRotationModel;


GlobalXRotationModel.prototype.getCurrentAngle = function(position){
    var subject = this.getSubject();
    var basePos = subject.getPosition();

    var vectorToCenter = position.sub(basePos);
    vectorToCenter.normalize();
    return Math.atan2(vectorToCenter.z, vectorToCenter.y);
}
 